export default __webpack_public_path__ + "static/mb-cs-deer-6ffa1b5c7ca2fdd82c3325580afd9d73.jpg";